module.exports = __webpack_public_path__ + "static/media/11-rectangle-available.ed4cf9af.svg";